// extracted by css-extract-rspack-plugin
var _1 = "column-name-pROw3e";
var _2 = "column-name-pROw3e";
var _3 = "filter-k0CZwg";
var _4 = "table-n6AjBK";
export { _1 as "column-name", _2 as "columnName", _3 as "filter", _4 as "table" }
